// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { baseUrl } from '../../../../app.config'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getReelsList = createAsyncThunk(
    'reelsUpload/getReelsList',
    async (params) => {

        const response = await axios.get(baseUrl() + '/reels/admin', { params })
        console.log("getReelsList response", response)

        return {
            totalPages: response.data.count.total,
            // params: response.data.params,
            data: response.data.data
        }
    }
)

export const allBusinessList = createAsyncThunk(
    'reelsUpload/allBusinessList',
    async (params) => {
        const response = await axios.get(baseUrl() + 'reels', { params })
        return {
            params: response.data.params,
            allBusinessList: response.data.result
        }
    }
)

export const uploadReel = createAsyncThunk(
    'reelsUpload/uploadReel',
    async ({ payload, params }, { dispatch, getState }) => {
        console.log("uploadReelsassa", params)

        try {
            await axios.post(baseUrl() + '/reels/add', payload)
            toast.success('Reel Added successfully')
            await dispatch(getReelsList(params))
            return true
        } catch (error) {
            toast.error(error?.response?.data?.message)
            return false
        }
    }
)

export const updatReel = createAsyncThunk(
    'reelsUpload/updatReel',
    async ({ id, payload, params }, { dispatch, getState }) => {
        console.log("updatReelss", params)

        try {
            await axios.put(baseUrl() + `/reels/update/${id}`, payload)
            toast.success('Reel Updated successfully')
            await dispatch(getReelsList(params))
            return true
        } catch (error) {
            toast.error(error?.response?.data?.message)
            return false
        }
    }
)

export const deleteReel = createAsyncThunk(
    'reelsUpload/deleteReel',
    async ({ id, params }, { dispatch, getState }) => {
        try {
            await axios.delete(baseUrl() + `/reels/${id}`),
                toast.success('Reel Deleted successfully')
            await dispatch(getReelsList(params))
            return true
        } catch (error) {
            toast.error(error?.response?.data?.message)
            return false
        }
    }
)

export const reelsUpload = createSlice({
    name: 'reelsUpload',
    initialState: {
        reelList: [],
        allBusinessList: [],
        reload: false,
        loader: false,
        rowsPerPage: 10,
        currentPage: 1,
        totalPages: 0,
        selected: null,
        clearFilter: false,
        status: '0',
        loading: false,
        params: {
            pageNo: 1,
            pageSize: 10
        },
        rowType: 'row1'


    },
    reducers: {
        selectReelUpload: (state, action) => {
            if (action.payload === null) {
                state.selected = null
            } else {
                state.selected = action.payload
            }
        },
        selectCurrentPage: (state, action) => {
            if (action.payload === null) {
                state.currentPage = null
            } else {
                state.currentPage = action.payload
            }
        },
        selectRowsPerPage: (state, action) => {
            if (action.payload === null) {
                state.rowsPerPage = null
            } else {
                state.rowsPerPage = action.payload
            }
        },
        selectClearFilter: (state, action) => {
            state.clearFilter = action.payload
        },
        setStatus: (state, action) => {
            state.status = action.payload
        },
        setLoader: (state) => {
            state.loader = !state.loader
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setRowType: (state, action) => {
            state.rowType = action.payload
        }
    },

    extraReducers: {
        [uploadReel.fulfilled]: (state, action) => {
            state.reload = !state.reload
        },
        [getReelsList.fulfilled]: (state, action) => {
            state.feedList = action.payload.data
            state.totalPages = action.payload.totalPages
            state.loader = false
        },
        [allBusinessList.fulfilled]: (state, action) => {
            state.allBusinessList = action.payload.allBusinessList
        },
        [updatReel.fulfilled]: (state, action) => {
            state.reload = !state.reload
            state.loader = false
        },
    }
})

export const { selectReelUpload, selectRowsPerPage, selectCurrentPage, setStatus, setLoader,
    setLoading, selectClearFilter, setRowType } = reelsUpload.actions

export default reelsUpload.reducer
